export default "__VITE_ASSET__vC3Y8zxe__"